import { Component, Input, OnInit } from '@angular/core';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';
import { getDateName } from '@usheru-hff/shared/utils';
import { FestivalEdition } from '@usheru-hff/shared/domain';
@Component({
    selector: 'ush-festival-item',
    templateUrl: './festival-item.component.html',
    styleUrls: ['./festival-item.component.scss'],
    standalone: false
})
export class FestivalItemComponent implements OnInit {
  constructor(private translationService: TranslationsService) {}

  mapIcon = faMapMarkerAlt;
  disabled = false;

  @Input() festivalEdition: FestivalEdition;
  festivalEditionDuration: string;

  ngOnInit(): void {
    let sameYear = false;
    const a = new Date(this.festivalEdition.dateFrom);
    const b = new Date(this.festivalEdition.dateTo);

    if (!this.festivalEdition.url) {
      this.disabled = true;
    }

    if (a.getFullYear() == b.getFullYear()) {
      sameYear = true;
    }

    this.festivalEditionDuration =
      (sameYear
        ? getDateName(this.festivalEdition.dateFrom, this.translationService.currentLanguage().code, {
            day: '2-digit',
            month: 'short'
          })
        : getDateName(this.festivalEdition.dateFrom, this.translationService.currentLanguage().code)) +
      ' - ' +
      getDateName(this.festivalEdition.dateTo, this.translationService.currentLanguage().code);
  }
}
